import PageTitle from "../components/PageTitle";
import PageHeader from "../components/PageHeader";
import __ from "../utils/translator";
import React, {Fragment, useEffect, useState} from "react";
import styled, {css} from "styled-components";
import UserStoreActions from "../flux/UserStoreActions";
import UserStore from "../flux/UserStore";
import JwtStore from "../flux/JwtStore";
import thronThumbnailResize from "../utils/thronThumbnailResize";
import thronPublicThumbnail from "../utils/thronPublicThumbnail";
import remToPixels from "../utils/remToPixels";
import ThronModal from "../components/ThronModal";
import Header from '../components/organisms/Header';

function getAssetSrc({ contentId, pKey }) {
  return thronThumbnailResize(thronPublicThumbnail(contentId, pKey), { height: remToPixels(11.75)});
}

function MobileNews() {
  const [news, setNews] = useState(null);
  const [asset, setAsset] = useState(null);

  useEffect(function() {
    const subscription = UserStore.addListener(() => {
      const user = UserStore.getState()
      setNews(user.news);
    });

    // For some reason, in the WebView on mobile we get a "Cannot dispatch in
    // the middle of a dispatch". So we fix it the usual way with a
    // setTimeout(fn, 0).
    const fetchTimeoutId = setTimeout(function() {
      UserStoreActions.fetch();
    }, 0);

    return function() {
      subscription.remove();
      clearTimeout(fetchTimeoutId);
    }
  },[]);

  return (
    <Fragment>
      <Header actions={['back']} />

      <PageTitle withTracking title="News" />

      <PageHeader
        smallTitle
        compact
        crumbs={[__('Home'), __('News')]}
        title={__('News')}
        style={{ height: 'auto' }} />

      <Container>
        {news === null ? (
          <span />
        ) : news.length === 0 ? (
          <p>{__('No news available')}</p>
        ) : news.map(item => (
          <NewsItem key={item.id}>
            <h3 style={{color: JwtStore.getLastLoginAt() < item.started_at ? '#78012B' : '#000'}}>
              {item.title}
            </h3>
            <NewsMediaContainer>
              <NewsMediaContainerInner>
                {item.assets.map(asset => (
                  <div
                    key={asset.id}
                    onClick={() => setAsset(asset)}
                    style={{
                      position: 'relative',
                      display: 'inline-block',
                      margin: '0 .5rem 0 .5rem'
                    }}
                  >
                    <NewsAsset src={getAssetSrc(asset)} />

                    {asset.type && asset.type.toLowerCase() === 'video' && (
                      <ImageOverlayIcon>
                        <svg viewBox="0 0 26 26" style={{
                          width: '3.25rem',
                          height: '3.25rem',
                        }}>
                          <g fill="none" fillRule="evenodd">
                            <path stroke="#979797" strokeWidth={.5} fillOpacity={.83} fill="#272727"
                                  d="M.25.25h25.5v25.5H.25z"/>
                            <path fill="#FFF" d="M16.073 12.934L10.4 17.046V8.82z"/>
                          </g>
                        </svg>
                      </ImageOverlayIcon>
                    )}
                  </div>
                ))}
              </NewsMediaContainerInner>
            </NewsMediaContainer>

            <p>{item.content}</p>

            {item.category !== null && (
              <NewsCategory>{item.category}</NewsCategory>
            )}
          </NewsItem>
        ))}

        {asset !== null && (
          <ThronModal asset={asset} onCloseButtonClick={() => setAsset(null)} />
        )}
      </Container>
    </Fragment>
  );
}

const Container = styled.div`
  padding: 0 1.25rem;

  > div {
    border-bottom: 0.0625rem solid rgb(0,0,0,.25);
    padding-bottom: 1.75rem;
  }

  > div:last-child {
    border-bottom: 0;
  }
`;

const NewsItem = styled.div`
  display: flex;
  flex-direction: column;

  > h3 {
    text-transform: uppercase;
    font-weight: bold;
    line-height: 1.625rem;
  }

  > p {
    font-family: 'Din-Light', sans-serif;
    line-height: 1.625rem;
    overflow: hidden;
  }
`;

const NewsCategory = styled.div`
  font-family: 'Din-Light', sans-serif;
  overflow: hidden;
`;

const NewsMediaContainer = styled.div`
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
`;

const NewsMediaContainerInner = styled.div`
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  margin-right: -.5rem;
  margin-left: -.5rem;
`;

const ImageOverlayIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  font-size: 0;
  cursor: pointer;
`;

const NewsAsset = styled.img`
  height: 14rem;
  box-shadow: rgba(37,37,37,.1) .0625rem .0625rem .125rem .0625rem;
  cursor: pointer;
`;

const NewsMedia = (props) => {
  return (
    <div {...props} style={{
      position: 'relative',
      display: 'inline-block',
      margin: '0 .5rem 0 .5rem'
    }} />
  )
};

export default MobileNews;
